if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(416|615|922|978)|(4|59)04|2145|2465|3718|3842|7900|9121|9968)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}